import React from "react";
import {
  Col,
  Row,
  Input,
  Label,
} from "reactstrap";
import ButtonSpinner from "../../../../components/Buttons/ButtonSpinner";

export default function ConfigurationsList({
  configValuesForm,
  setConfigValuesForm,
  trySaveConfigs,
}) {
  if (!configValuesForm) {
    return null;
  }
  return (
    <div style={{ paddingBottom: '10px' }}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          trySaveConfigs(e);
        }}
      >
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <div>
              <Label htmlFor="formFile" className="form-label">
                Em qual sistema está a base de participantes?
              </Label>
              <select
                className="form-control"
                onChange={(e) => setConfigValuesForm({ ...configValuesForm, ['SYSTEM_BASE']: e.target.value })}
                value={configValuesForm['SYSTEM_BASE']}
              >
                <option value=''>Selecione</option>
                <option value='INTEEGRA_EVENTOS'>Inteegra Eventos</option>
                <option value='MICE'>Mice</option>
                {/* <option value='MICE_SANT'>Mice Sant</option> */}
              </select>
            </div>
            {
              configValuesForm['SYSTEM_BASE'] !== 'INTEEGRA_EVENTOS' &&
              configValuesForm['SYSTEM_BASE'] !== '' && (
                <div style={{ paddingTop: '10px' }}>
                  <Label htmlFor="formFile" className="form-label">
                    Qual o ID do evento da base de participantes?
                  </Label>
                  <Input
                    className="form-control"
                    type="text"
                    value={configValuesForm['SYSTEM_BASE_ID']}
                    onChange={(e) => setConfigValuesForm({ ...configValuesForm, ['SYSTEM_BASE_ID']: e.target.value })}
                  />
                </div>
              )
            }
          </Col>
        </Row>

        <Row
          style={{
            width: "100%",
            margin: "auto",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <ButtonSpinner
            // isLoading={isLoading} 
            title={"Salvar"}
          />
        </Row>
      </form>
    </div>
  )
}
